import { useAdminClientesAsesoria, type ClienteAsesoria } from '../../../../hooks/useAdminClientesAsesoria';

interface Props {
  selectedCliente: number;
  onChange: (id: number) => void;
  loadingPerfil: boolean;
  savedOk: boolean;
  onSave: () => void;
  onRefresh: () => void;
}

export default function ClienteSelector({
  selectedCliente,
  onChange,
  loadingPerfil,
  savedOk,
  onSave,
  onRefresh,
}: Props) {
  const { data: clientes } = useAdminClientesAsesoria();
  const current = clientes.find((c) => c.id === selectedCliente);

  return (
    <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
      <div className="flex items-center gap-4">
        <h2 className="font-serif text-brand-black text-2xl font-medium">
          Perfil del Cliente
        </h2>
        <div className="relative">
          <select
            value={selectedCliente}
            onChange={(e) => onChange(Number(e.target.value))}
            className="appearance-none bg-white border border-brand-gray-200 rounded-lg pl-4 pr-10 py-2.5 font-sans text-sm focus:outline-none focus:border-brand-black cursor-pointer"
          >
            {clientes.map((c: ClienteAsesoria) => (
              <option key={c.id} value={c.id}>
                {c.nombre}
              </option>
            ))}
          </select>
          <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-brand-gray-400">
            <i className="ri-arrow-down-s-line" />
          </div>
        </div>
        {current && (
          <span className="inline-block px-2.5 py-1 rounded-full font-sans text-[11px] uppercase tracking-wider font-medium bg-brand-sage/20 text-brand-black">
            {current.plan_contratado || 'Sin plan'}
          </span>
        )}
      </div>

      <div className="flex items-center gap-3">
        <button
          onClick={onSave}
          disabled={loadingPerfil}
          className="inline-flex items-center gap-2 bg-brand-black text-white font-sans text-sm px-5 py-2.5 rounded-lg hover:bg-brand-gray-600 transition-colors whitespace-nowrap disabled:opacity-60"
        >
          {loadingPerfil ? (
            <>
              <i className="ri-loader-4-line animate-spin" />
              Guardando...
            </>
          ) : savedOk ? (
            <>
              <i className="ri-check-line" />
              Guardado
            </>
          ) : (
            <>
              <i className="ri-save-line" />
              Guardar perfil
            </>
          )}
        </button>
        <button
          onClick={onRefresh}
          className="w-10 h-10 rounded-lg bg-white border border-brand-gray-200 flex items-center justify-center text-brand-gray-600 hover:text-brand-black hover:border-brand-black transition-colors"
          title="Recargar"
        >
          <i className="ri-refresh-line" />
        </button>
      </div>
    </div>
  );
}